import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  IconButton,
  Button,
  FormControl,
  MenuItem,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import RequiredLabel from "../../shared/RequiredLabel";
import ConfirmDeleteDialog from "../../shared/ConfirmDeleteDialog";

const RoleExperience = ({
  roles,
  onChange,
  onAdd,
  onRemove,
  isRequired = false,
  endpoint = "/role_autocomplete",
}) => {
  const [roleOptions, setRoleOptions] = useState([]);

  // 削除確認ダイアログの状態
  const [deleteTargetIndex, setDeleteTargetIndex] = useState(null);

  useEffect(() => {
    fetch(endpoint)
      .then((res) => res.json())
      .then((data) => setRoleOptions(data))
      .catch((err) => console.error("役割一覧取得エラー:", err));
  }, [endpoint]);

  const handleChange = (index, field, value) => {
    const updated = [...roles];
    updated[index] = { ...updated[index], [field]: value };
    onChange(updated);
  };

  const handleRoleSelect = (index, selected) => {
    if (selected) {
      handleChange(index, "role_id", selected.id);
    } else {
      handleChange(index, "role_id", null);
    }
  };

  const handleDeleteConfirm = (index) => {
    // 役割名か経験年数が入力されている場合は削除確認ダイアログを表示
    const role = roles[index];
    const hasContent =
      (role.role_id !== null && role.role_id !== undefined) ||
      (role.experience_year && String(role.experience_year).trim() !== "");

    if (hasContent) {
      setDeleteTargetIndex(index);
    } else {
      onRemove(index);
    }
  };

  return (
    <Box>
      {/* 見出し */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography sx={{ fontSize: 14 }}>ポジション</Typography>
        <RequiredLabel show={isRequired} />
      </Box>

      {roles.map((role, index) => (
        <Grid
          container
          spacing={2}
          alignItems="center"
          key={index}
          sx={{ mb: 2 }}
        >
          {/* 役割選択 */}
          <Grid item xs={12} sm={8}>
            <FormControl fullWidth>
              <TextField
                select
                placeholder="役割を選択"
                value={role.role_id || ""}
                onChange={(e) => handleChange(index, "role_id", e.target.value)}
                variant="outlined"
                fullWidth
                SelectProps={{
                  displayEmpty: true,
                }}
                InputLabelProps={{
                  shrink: false,
                }}
                sx={{
                  "& .MuiOutlinedInput-root input": {
                    border: "none",
                    boxShadow: "none",
                  },
                  "& .MuiSelect-select": {
                    color: role.role_id ? "inherit" : "gray",
                  },
                }}
              >
                <MenuItem value="" disabled>
                  役割を選択
                </MenuItem>
                {roleOptions
                  .filter((opt) => {
                    const selectedIds = roles
                      .map((r) => r.role_id)
                      .filter((id) => id !== null);
                    return (
                      !selectedIds.includes(opt.id) || opt.id === role.role_id
                    );
                  })
                  .map((opt) => (
                    <MenuItem key={opt.id} value={opt.id}>
                      {opt.name}
                    </MenuItem>
                  ))}
              </TextField>
            </FormControl>
          </Grid>

          {/* 経験年数 */}
          <Grid item xs={6} sm={2}>
            <TextField
              fullWidth
              type="number"
              placeholder="経験年数"
              inputProps={{ min: 0 }}
              value={role.experience_year || ""}
              onChange={(e) => {
                const val = e.target.value;
                if (val.length <= 3) {
                  handleChange(index, "experience_year", val);
                }
              }}
              sx={{
                "& .MuiOutlinedInput-root input": {
                  border: "none",
                  boxShadow: "none",
                },
              }}
            />
          </Grid>

          {/* 単位表示 */}
          <Grid item xs={3} sm={1}>
            <Typography sx={{ mt: 3 }}>年以上</Typography>
          </Grid>

          {/* 削除ボタン */}
          <Grid item xs={3} sm={1}>
            <IconButton
              color="error"
              onClick={() => handleDeleteConfirm(index)}
            >
              <Delete />
            </IconButton>
          </Grid>
        </Grid>
      ))}

      {/* 追加ボタン */}
      <Button
        variant="contained"
        onClick={onAdd}
        sx={{
          backgroundColor: "#818cf8",
          fontWeight: "bold",
          "&:hover": { backgroundColor: "#6366f1" },
        }}
      >
        ＋ポジションを追加する
      </Button>

      {/* 削除確認ダイアログ */}
      <ConfirmDeleteDialog
        open={deleteTargetIndex !== null}
        onClose={() => setDeleteTargetIndex(null)}
        onConfirm={() => {
          if (deleteTargetIndex !== null) {
            onRemove(deleteTargetIndex);
            setDeleteTargetIndex(null);
          }
        }}
      />
    </Box>
  );
};

export default RoleExperience;
